<template>
  <div class="table-container">
    <b-overlay center :show="isLoading" rounded="sm">
      <div v-if="!isLoading">
        <div v-if="ok">
          <validation-observer ref="observer" v-slot="{ invalid, handleSubmit }">
            <b-form @submit.prevent="">
              <div class="form-card-wrapper">
                <b-card header-tag="header">
                  <template #header>
                    <b>Dati Generali</b>
                  </template>
                  <b-card-text>
                    <b-row>
                      <div class="form-group">
                        <base-input
                          vid="template_name"
                          :name="beForm[rep].template_name.label"
                          :label="beForm[rep].template_name.label"
                          v-model="form[rep].template_name"
                          placeholder="Inserisci un nome"
                          :rules="getRules('template_name')"
                        />
                      </div>
                      <div class="form-group">
                        <base-select
                          vid="taskable_type"
                          :name="beForm[rep].taskable_type.label"
                          :label="beForm[rep].taskable_type.label"
                          v-model="form[rep].taskable_type"
                          :options="beForm[rep].taskable_type.options"
                          :taggable="false"
                          :multiple="false"
                          :closeOnSelect="true"
                          :rules="getRules('taskable_type')"
                        />
                      </div>
                    </b-row>
                    <b-row>
                      <div class="form-group">
                        <base-input
                          vid="title"
                          :name="beForm[rep].title.label"
                          :label="beForm[rep].title.label"
                          v-model="form[rep].title"
                          placeholder="Inserisci il titolo della nota"
                          maxlength="25"
                          :rules="getRules('title')"
                        />
                      </div>
                    </b-row>
                    <b-row>
                      <div class="form-group" style="grid-column: 1 / -1">
                        <base-textarea
                          vid="description"
                          :name="beForm[rep].description.label"
                          :label="beForm[rep].description.label"
                          v-model="form[rep].description"
                          placeholder="Inserisci il testo della nota"
                          :rules="getRules('description')"
                        />
                      </div>
                    </b-row>
                  </b-card-text>
                </b-card>
              </div>
              <div class="form-actions form-actions--sticky">
                <div class="inner-wrapper">
                  <div>
                    <span
                      :title="`${
                        invalid
                          ? 'Compila correttamente i campi per poter salvare'
                          : 'Invia il form'
                      }`"
                    >
                      <b-button
                        @click="handleSubmit(onSubmit)"
                        type="button"
                        :disabled="invalid"
                        variant="lisaweb"
                        size="sm"
                      >
                        Salva
                      </b-button>
                    </span>
                    <b-button
                      @click="resetForm()"
                      class="btn--transparent btn-reset"
                      type="button"
                      title="Pulisci tutti i campi e compila il form nuovamente"
                      >Reset
                    </b-button>
                  </div>
                  <div>
                    <b-button
                      @click="goBack()"
                      class="btn--transparent"
                      type="button"
                      title="Torna alla pagina precedente"
                    >
                      <b-icon-chevron-double-left
                        font-scale="0.9"
                      ></b-icon-chevron-double-left>
                      Torna indietro
                    </b-button>
                  </div>
                </div>
              </div>
            </b-form>
          </validation-observer>
        </div>
        <div v-else>
          {{ errorMessage }}
        </div>
      </div>
      <template #overlay>
        <div class="text-center">
          <div class="custom-loader"></div>
          <p class="loading-text">Operazione in corso...</p>
        </div>
      </template>
    </b-overlay>
  </div>
</template>

<script>
import ShortcutMixin from "@/mixins/ShortcutMixin";
import FormMixin from "@/mixins/FormMixin";
import BaseInput from "@/components/form/BaseInput";
import BaseSelect from "@/components/form/BaseSelect";
import BaseTextarea from "@/components/form/BaseTextarea";

export default {
  mixins: [FormMixin, ShortcutMixin],
  data() {
    return {
      repository: "note_template",
      id: this.$route.params.id,
      form: {
        note_template: {
          template_name: null,
          taskable_type: null,
          title: null,
          description: null,
        },
      },
    };
  },
  components: {
    BaseInput,
    BaseSelect,
    BaseTextarea,
  },
  methods: {
    goBack() {
      this.$router.back();
    },
    onSubmit() {
      this.isLoading = true;
      this.store(this.repository)
        .then(() => {
          this.$showSnackbar({
            preset: "success",
            text: `Azione Completata: template nota creato`,
          });
          this.shortcut(
            "note_templates.index",
            null,
            null,
            "filterNoteTemplates",
          );
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
  created() {
    this.isLoading = true;
    this.fetchCreateForm(this.repository).then(() => {
      this.isLoading = false;
    });
  },
  computed: {
    rep() {
      return this.repository;
    },
  },
};
</script>
